<template>
  <v-main>
    <v-container fluid>
      <!-- Card Header -->
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() ? 'Deleted sub_categories' : 'Sub Categories'
                "
              ></h3>
              <template v-if="!isDeletePage()">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  :to="`/categories/${categoryId}/sub-categories/create`"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-card-title>

            <!-- Filters Section -->
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ..."
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="resetFilters"
                    @keydown.enter="getData"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="clearStatusFilter"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Subcategories Table Section -->
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <!-- Loading Spinner -->
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>

              <!-- Subcategories Table -->
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start sr_no">Sr No</th>
                      <th class="text-left">Subcategory Name</th>
                      <!-- <th class="text-start">Add Sub 2 Categories</th> -->
                      <th class="text-left">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="subcategories.length">
                    <tr
                      v-for="(subcategory, i) in subcategories"
                      :key="subcategory.id"
                    >
                      <td>{{ (page - 1) * 10 + (i + 1) }}</td>
                      <td>{{ subcategory.name }}</td>
                      <!-- <td>
                        <v-btn
                          class="mx-2 mb-2"
                          color="primary"
                          small
                          :to="`/categories/${
                            $route.params.categoryId
                          }/sub-categories/${encryptIt(
                            subcategory.id
                          )}/sub-2-categories`"
                        >
                          Add New
                        </v-btn>
                      </td> -->
                      <td class="text-left">
                        <template v-if="!isDeletePage()">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                class="mr-2"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="error"
                                @click="deleteSub(subcategory.id)"
                              >
                                <v-icon dark>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Subcategory</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="primary"
                                :to="`/categories/${categoryId}/sub-categories/${encryptIt(
                                  subcategory.id
                                )}`"
                              >
                                <v-icon dark>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Subcategory</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="success"
                                @click="restoreSub(subcategory.id)"
                              >
                                <v-icon dark>mdi-delete-restore</v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this Subcategory</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4" class="text-center">
                        No subcategories found
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Success Dialog Boxes -->
      <v-dialog v-model="isDeletedSubcategory" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon large style="color: green; font-size: 90px"
                  >mdi-delete-empty</v-icon
                >
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <h1 style="color: green">Hurray!</h1>
                  <h3>Subcategory deleted successfully.</h3>
                  <v-btn color="success" @click="isDeletedSubcategory = false"
                    >OK</v-btn
                  >
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="isRestoredSubcategory" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon large style="color: green; font-size: 90px"
                  >mdi-delete-restore</v-icon
                >
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <h1 style="color: green">Hurray!</h1>
                  <h3>Subcategory restored successfully.</h3>
                  <v-btn color="success" @click="isRestoredSubcategory = false"
                    >OK</v-btn
                  >
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "SubCategoriesPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      subcategories: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      isLoading: false,
      isDeletedSubcategory: false,
      isRestoredSubcategory: false,
    };
  },
  computed: {
    categoryId() {
      return this.$route.params.categoryId;
    },
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.search_keyword = this.filter.search_keyword || "";
      this.filter.is_active = this.filter.is_active || "";
      let query = `page=${this.page}&rowsPerPage=${
        this.rowsPerPage
      }&show_deleted=${this.filter.show_deleted}&is_active=${
        this.filter.is_active
      }&search_keyword=${this.filter.search_keyword}&parent_id=${this.decryptIt(
        this.categoryId
      )}`;
      await axios
        .get(`categories?${query}`)
        .then((response) => {
          this.subcategories = response.data.data;
          this.count = this.subcategories.length;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },

    async deleteSub(id) {
      try {
        await axios.post(`/categories/delete/${this.encryptIt(id)}`);
        this.isDeletedSubcategory = true;
        this.getData();
      } catch (error) {
        console.error(error);
      }
    },
    async restoreSub(id) {
      try {
        await axios.post(`/categories/restore/${id}`);
        this.isRestoredSubcategory = true;
        this.getData();
      } catch (error) {
        console.error(error);
      }
    },
    resetFilters() {
      this.filter.search_keyword = "";
      this.page = 1;
      this.getData();
    },
    clearStatusFilter() {
      this.filter.is_active = "";
      this.page = 1;
      this.getData();
    },
    isDeletePage() {
      return this.$route.query.open_trash === "1";
    },
  },
};
</script>
